/* tslint:disable max-line-length */
import { Component, OnInit, AfterViewInit, Renderer2, Inject } from '@angular/core';
import { ToolSettingsService } from 'src/app/service/tool-settings/tool-settings.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { TableData } from 'src/app/shared/models/tableData';
import { checkForProp } from '../tool-transfer/tool-transfer.functions';
import { DOCUMENT } from '@angular/common';
import { ToolPermissionsService } from 'src/app/service/auth/tool-permissions.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';

@Component({
  selector: 'app-tool-model-list',
  templateUrl: './tool-model-list.component.html',
  styleUrls: ['./tool-model-list.component.scss'],
})
export class ToolModelListComponent implements OnInit, AfterViewInit {
  defaultSortOrder = ''

  constructor(
    private toolSettingsService: ToolSettingsService,
    /* tslint:disable-next-line variable-name */
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    private toolPermissionsService: ToolPermissionsService,
    private loaderService: LoaderService,
  ) { }

  searchParams: ToolSearchParams = {
    page: 1,
    limit: 50,
    embed: 'category,manufacturer',
  };

  toolModelExportParams: ToolSearchParams = {
    embed: 'category,manufacturer',
  };

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  filters: Array<any> = [
    {
      label: 'Asset Class',
      type: 'select2MultipleWithCheck',
      propertyName: 'scope[assetClass]',
      default: '',
      value: 'id',
      model: 'asset-classes',
      options: [],
      name: 'name',
      loadOptions: () => this.loadOptions('asset-classes'),
    },
    {
      label: 'Category',
      type: 'select2',
      propertyName: 'scope[category]',
      default: '',
      model: 'categories',
      options: [],
      name: 'name',
      loadOptions: () => this.loadOptions('categories'),
    },
    {
      label: 'Manufacturer',
      type: 'select2',
      propertyName: 'scope[manufacturer]',
      default: '',
      value: 'id',
      model: 'manufacturers',
      options: [],
      name: 'name',
      loadOptions: () => this.loadOptions('manufacturers'),
    },
    {
      label: 'Status',
      type: 'select',
      propertyName: 'scope[enabled]',
      value: 'id',
      default: true,
      model: 'enabled',
      name: 'name',
      options: [
        { id: '', name: 'All' },
        { id: true, name: 'Active' },
        { id: false, name: 'Inactive' },
      ],
    },
  ];

  tableData: TableData = {
    label: 'Model',
    type: 'models',
    statusToggle: true,
    columns: [
      {
        name: 'name',
        label: 'Description',
        sortable: true,
        property: 'name',
        columnStyles: { 'max-width': '200px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '15rem' },
        columnClasses: { 'text-truncate': true, another: true },
      },
      {
        name: 'assetClass',
        label: 'Asset Class',
        sortable: true,
        property: x => checkForProp(x, 'category.assetClass.name'),
        headerStyles: { 'min-width': '104px', display: 'none' },
        columnStyles: { 'max-width': '120px', display: 'none' },
        columnClasses: { 'text-truncate': true, another: true },
      },
      {
        name: 'category',
        label: 'Category',
        sortable: true,
        property: x => checkForProp(x, 'category.name'),
        columnStyles: { 'min-width': '100px', 'max-width': '7%' },
        columnClasses: { 'text-truncate': true, another: true },
      },
      {
        name: 'manufacturer',
        label: 'Manufacturer',
        sortable: true,
        property: x => checkForProp(x, 'manufacturer.name'),
        columnStyles: { 'max-width': '120px' },
        columnClasses: { 'text-truncate': true, another: true },
      },
      {
        name: 'description',
        label: 'Model',
        sortable: true,
        property: 'description',
        columnStyles: { 'max-width': '210px' },
        columnClasses: { 'text-truncate': true, another: true },
      },
      {
        name: 'rentalPriceDaily',
        label: 'Daily Fee',
        sortable: true,
        property: x => this.formatToCurrency(x.rentalPriceDaily),
        headerStyles: { 'min-width': '92px' },
      },
      {
        name: 'rentalPriceWeekly',
        label: 'Weekly Fee',
        sortable: true,
        property: x => this.formatToCurrency(x.rentalPriceWeekly),
        headerStyles: { 'min-width': '106px' },
      },
      {
        name: 'rentalPriceMonthly',
        label: 'Monthly Fee',
        sortable: true,
        property: x => this.formatToCurrency(x.rentalPriceMonthly),
        headerStyles: { 'min-width': '112px' },
      },
      {
        name: 'maintenanceRequired',
        label: 'Weekly Maint.',
        sortable: true,
        property: x => (x.maintenanceRequired ? 'Yes' : 'No'),
        headerStyles: { 'min-width': '123px' },
      },
      {
        name: 'inspectionRequired',
        label: 'Annual Insp.',
        sortable: true,
        property: x => (x.inspectionRequired ? 'Yes' : 'No'),
        headerStyles: { 'min-width': '113px' },
      },
    ],
    rowActions: [
      {
        label: 'Add',
        actionId: 'add',
        imageUrl: '',
        iconName: 'far fa-plus',
        show: row => {
          return this.toolPermissionsService.isAllowed(row, 'tool_models', 'edit');
        },
      },
      {
        label: 'Copy',
        actionId: 'copy',
        imageUrl: '',
        iconName: 'far fa-clone',
        show: row => {
          return this.toolPermissionsService.isAllowed(row, 'tool_models', 'edit');
        },
      },
      {
        label: 'Edit',
        actionId: 'edit',
        imageUrl: '',
        iconName: 'far fa-pen',
        show: row => {
          return this.toolPermissionsService.isAllowed(row, 'tool_models', 'edit');
        },
      },
      {
        label: 'Delete',
        actionId: 'delete',
        imageUrl: '',
        iconName: 'far fa-trash',
        show: row => {
          return this.toolPermissionsService.isAllowed(row, 'tool_models', 'admin');
        },
      },
    ],
    data: [],
    pagination: {},
  };

  dialogRecord: any = {};

  get attributes() {
    const attributes = [
      'id',
      'name',
      'description',
      'enabled',
      'rentalPriceDaily',
      'rentalPriceMonthly',
      'rentalPriceWeekly',
      'inspectionRequired',
      'maintenanceRequired',
      'category.name',
      'category.assetClass.name',
      'manufacturer.name',
    ];
    return attributes.join(',');
  }

  get searchFields() {
    const fields = [
      'name',
      'modelYear',
      'description',
      'category.name',
      'category.assetClass.name',
      'manufacturer.name',
    ];
    return fields.join(',');
  }

  ngOnInit(): void {
    this.loaderService.displayLoader();
  }

  loadOptions(key: string): void {
    // loop through modelDetails object and capture information from API
    // call the API for this endpoint 'key' and store result in modelDetail[key]
    this.toolSettingsService.read[key]({ limit: 1000 }).subscribe(
      res => {
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;

        // establish the list of options for the select elements
        this.filters.forEach(filter => {
          if (filter.model === key) {
            filter.options = res.data;
          }
        });
      },
      error => {
        console.error(error);
      },
    );
  }

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  formatToCurrency(amt: number) {
    if (amt) {
      let isNegative = false;
      if (amt < 0) {
        isNegative = true;
        amt *= -1;
      }

      const currency = amt.toLocaleString('en-US', {
        minimumFractionDigits: 2,
      });
      return isNegative ? `($${currency})` : `$${currency}`;
    }
  }
}
